<template>
    <div class="page-container cloudlet">

        <backup-settings v-if="file" :file-id="file.id"></backup-settings>

        <div v-if="file">
            <div class="columns is-multiline">
                <div class="column is-10 p-bottom-0">
                    <div class="dropdown is-left is-hoverable dropdown-trigger">
                        <div class="name">
                            <font-awesome-icon icon="folder"/>&nbsp;&nbsp;{{ fileTitle }}
                            <span style="display: inline-block; margin-left:3px; font-size:12px;">
                                <font-awesome-icon icon="chevron-down"/>
                            </span>    
                        </div>
                        <div class="dropdown-menu" role="menu">
                            <div class="dropdown-content">
                                <a @click="createBackup" class="dropdown-item">
                                    <font-awesome-icon icon="save" class="dropdown-action-icon"/>Take backup now
                                </a>
                                <hr class="navbar-divider">
                                <a @click="togglePaused" class="dropdown-item">
                                    <font-awesome-icon v-if="!file.paused" icon="pause" class="dropdown-action-icon" />
                                    <font-awesome-icon v-if="file.paused" icon="play" class="dropdown-action-icon" />
                                    {{ pausedActionLabel }}
                                </a>
                                <a @click="showChangeFileStorageModal" class="dropdown-item">
                                    <font-awesome-icon icon="hdd" class="dropdown-action-icon"/>Change storage
                                </a>
                                <a @click="showConfigureBackupOptionsModal" class="dropdown-item">
                                    <font-awesome-icon icon="cog" class="dropdown-action-icon"/>Configure backup options
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column is-2 has-text-right" style="padding-bottom:0;">
                    <div class="tooltip is-pulled-right status-icon-container" :data-tooltip="statusIconTooltip">
                        <!-- <font-awesome-icon v-if="monitor.disabled > 0" icon="ban" class="has-text-grey-light" /> -->
                        <!-- <font-awesome-icon v-if="monitorStatusIs('inactive') && !monitor.paused && !monitor.disabled" icon="stop-circle" class="has-text-grey-light" /> -->
                        <!-- <font-awesome-icon v-if="monitorStatusIs('exec_timeout') && !monitor.paused" icon="exclamation-triangle" class="has-text-danger" /> -->
                        <!-- <font-awesome-icon v-if="monitorStatusIs('active') && !monitor.paused" icon="check-circle" class="has-text-success" /> -->
                        <font-awesome-icon v-if="showDeletedFromProviderIcon" :icon="['far', 'times-circle']" class="has-text-danger" />
                        <!-- <font-awesome-icon v-if="monitorStatusIs('running') && !monitor.paused" icon="circle-notch" class="has-text-info" /> -->
                        <!-- <font-awesome-icon v-if="monitor.paused > 0" icon="pause-circle" class="has-text-warning" /> -->
                        <font-awesome-icon v-if="showActiveStatusIcon" icon="check-circle" class="has-text-success" style="font-size: 22px;" />
                        <font-awesome-icon v-if="showPausedStatusIcon" icon="pause-circle" class="has-text-warning" style="font-size: 22px;" />
                    </div>
                </div>
                <div class="column is-12" style="padding-top:0;padding-bottom:0">
                    <div class="extra-info">
                        Server:
                        <router-link :to="{ name: 'serverSettings', params: { id: file.server.id } }" style="color: #999;">
                            <span class="hoverable-text">{{ file.server.name }}</span>
                        </router-link>
                    </div>
                </div>
            </div>

            <!-- <div v-if="cloudlet.deleted_from_provider" class="notification is-danger notification-text-size m-top-20">
                This cloudlet has been deleted from {{ cloudlet.provider.name }}. Is not possible to take new snapshots anymore.
            </div> -->

            <!-- <div v-if="database.paused && !cloudlet.deleted_from_provider" class="notification is-warning notification-text-size m-top-20"> -->
            <div v-if="file.paused" class="notification is-warning notification-text-size m-top-20" style="margin-bottom: 15px;">
                No new backups are taken for this database because it's paused.
            </div>

            <div class="cloudlet-stats">
                <div class="columns is-multiline">
                    <div class="column is-full">
                        <span style="font-size: 14px;font-weight:600;">Details & Stats</span>
                    </div>
                    <div class="column is-3" style="padding-top:0">
                        <div class="stats-box">
                            <div class="columns">
                                <div class="column is-3">
                                    <div class="stats-icon">
                                        <font-awesome-icon icon="clock"/>
                                    </div>
                                </div>
                                <div class="column is-9">
                                    <h2 class="stats-title">Next backup</h2>
                                    <h3 class="stats-description">{{ file.next_backup_human_diff ? file.next_backup_human_diff : '-' }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-3" style="padding-top:0">
                        <div class="stats-box">
                        <div class="columns">
                                <div class="column is-3">
                                    <div class="stats-icon">
                                        <font-awesome-icon icon="play" class="active-backups-icon"/>
                                    </div>
                                </div>
                                <div class="column is-9">
                                    <h2 class="stats-title">Active backups</h2>
                                    <h3 class="stats-description">{{ file.backups_count }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-3" style="padding-top:0">
                        <div class="stats-box">
                        <div class="columns">
                                <div class="column is-3">
                                    <div class="stats-icon">
                                        <font-awesome-icon icon="hdd"/>
                                    </div>
                                </div>
                                <div class="column is-9">
                                    <h2 class="stats-title">Storage usage</h2>
                                    <h3 class="stats-description">{{ backupsStorage }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-3" style="padding-top:0">
                        <div class="stats-box">
                        <div class="columns">
                                <div class="column is-3">
                                    <div class="stats-icon">
                                        <font-awesome-icon icon="stopwatch"/>
                                    </div>
                                </div>
                                <div class="column is-9">
                                    <h2 class="stats-title">Avgerage backup duration</h2>
                                    <h3 class="stats-description">{{ file.average_backup_duration + ' min' }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="backup">
                <div class="columns is-multiline">
                    <div class="column is-full" style="padding-bottom:0">
                        <!-- Frequency & Retention -->
                        <span style="font-size:14px;font-weight:600">Frequency & Retention</span>
                    </div>
                    <div class="column" :class="{'is-one-fifth': multipleSnapshotsPerDay, 'is-3': !multipleSnapshotsPerDay}">
                        <div @click="showBackupSettings()" class="backup-frequency">
                            <div class="icon">
                                <font-awesome-icon icon="history"/>
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Frequency
                                </div>
                                <div class="detail-value">
                                    {{ frequencyLabel }}
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div v-if="multipleSnapshotsPerDay" class="column" :class="{'is-one-fifth': multipleSnapshotsPerDay, 'is-3': !multipleSnapshotsPerDay}">
                        <div @click="showBackupSettings('frequentlyRetention')" class="backup-retention">
                            <div class="icon">
                                <font-awesome-icon icon="calendar-day"/>
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    {{ frequentlyRetentionTitle }}
                                </div>
                                <div class="detail-value">
                                    {{ frequentlyRetentionLabel }}
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div class="column" :class="{'is-one-fifth': multipleSnapshotsPerDay, 'is-3': !multipleSnapshotsPerDay}">
                        <div @click="showBackupSettings('dailyRetention')" class="backup-retention">
                            <div class="icon">
                                <font-awesome-icon icon="calendar-day"/>
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Daily backups retention
                                </div>
                                <div class="detail-value">
                                    {{ dailyRetentionLabel }}
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div class="column" :class="{'is-one-fifth': multipleSnapshotsPerDay, 'is-3': !multipleSnapshotsPerDay}">
                        <div @click="showBackupSettings('weeklyRetention')" class="backup-retention">
                            <div class="icon">
                                <font-awesome-icon icon="calendar-week"/>
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Weekly backups retention
                                </div>
                                <div class="detail-value">
                                    {{ weeklyRetentionLabel }}
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div class="column" :class="{'is-one-fifth': multipleSnapshotsPerDay, 'is-3': !multipleSnapshotsPerDay}">
                        <div @click="showBackupSettings('monthlyRetention')" class="backup-retention">
                            <div class="icon">
                                <font-awesome-icon icon="calendar"/>
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Monthly backups retention
                                </div>
                                <div class="detail-value">
                                    {{ monthlyRetentionLabel }}
                                </div>
                            </diV>
                        </div>
                    </div>
                </div>
            </div>

            <file-backups :file="file"></file-backups>
        </div>

        <change-file-storage v-if="changeFileStorageModalIsVisible" :file="file"></change-file-storage>
        <configure-backup-options v-if="configureBackupOptionsModalIsVisible" :file="file"></configure-backup-options>
    </div>
</template>

<style>
.status-icon-container {
    width: 25px;
}
</style>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';
import FileBackups from '@/components/Files/FileBackups.vue';
import BackupSettings from '@/components/Files/BackupSettings.vue';
import ChangeFileStorage from '@/components/Files/ChangeFileStorage.vue';
import ConfigureBackupOptions from '@/components/Files/ConfigureBackupOptions.vue'; 

export default {
    name: 'dashboard',

    components: {
        FileBackups,
        BackupSettings,
        ChangeFileStorage,
        ConfigureBackupOptions,
    },

    metaInfo: {
        title: 'File backups - Weap.io',
    },

    data() {
        return {
            file: null,
            changeFileStorageModalIsVisible: false,
            configureBackupOptionsModalIsVisible: false,
        }
    },

    mounted() {
        this.listenEvents();
        this.getFile();
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (vm.$route.query.file_created) {
                swal('Success!', 'The file backup was created. As next step you should review the frequency & retention policy.', 'success');
            }
        });
    },

    methods: {
        getFile(successCallback) {
            let endpoint = 'files/' + this.$route.params.id + '?detailed=true';
            Api().get(endpoint)
                .then((response) => {
                    this.file = response.data.data;
                    if (typeof successCallback == 'function') {
                        successCallback();
                    }
                })
                .catch((error) => {
                    //
                })
                .finally(() => {
                    //
                });
        },

        createBackup() {
            let endpoint = 'files/' + this.$route.params.id + '/backups';
            Api().post(endpoint)
                .then((response) => {
                    Event.$emit('refreshBackups', () => {
                        Event.$emit('showFileBackupDetailsModal', response.data.data);
                        // Swal.fire({
                        //     title: 'Great!',
                        //     text: 'The backup was enqueed and will be picked up by a worker as soon as possible.',
                        //     type: 'success',
                        // });
                    });
                })
                .catch((error) => {
                    if (error.response.status == 409) {
                        Swal.fire({
                            title: 'Oops',
                            text: 'The last backup is still pending or in progress. Wait until it\'s done before creating a new one.',
                            type: 'error',
                        });
                    } else if (error.response.status == 423) {
                        Swal.fire({
                            title: 'Oops',
                            text: 'This file schedule does not have a cloud storage. Attach one and try again.',
                            type: 'error',
                        });
                    }
                });
        },

        showChangeFileStorageModal() {
            this.changeFileStorageModalIsVisible = true;
        },

        showConfigureBackupOptionsModal() {
            this.configureBackupOptionsModalIsVisible = true;
        },

        togglePaused() {
            // if (this.cloudlet.deleted_from_provider) {
            //     return;
            // }

            let endpoint = 'files/' + this.$route.params.id + '/paused';
            Api().put(endpoint)
                .then((response) => {
                    this.getFile(() => {
                        var action = 'resumed';
                        var title = 'Great!';

                        if (this.file.paused) {
                            action = 'paused';
                            title = 'Done!';
                        }

                        Swal.fire({
                            title: title,
                            text: 'The automatic file backups are ' + action + '.',
                            type: 'success',
                        });

                    });
                })
                .catch((error) => {
                    if (typeof error.response.data.message == 'string' && typeof error.response.data.title == 'string') {
                        var title = error.response.data.title;
                        var message = error.response.data.message;
                    } else {
                        var title = 'Ooops';
                        var message = 'Something wrong happened.';
                    }

                    Swal.fire({
                        title: title,
                        text: message,
                        type: 'error',
                    });
                })
                .finally(() => {
                    //
                });
        },

        showBackupSettings(selectedOption) {
            Event.$emit('showBackupSettings', selectedOption);
        },

        // showReplicationRegions() {
        //     Event.$emit('showReplicationRegions');
        // },

        listenEvents() {
            Event.$on('refreshFile', (callback) => {
                this.getFile(callback);
            });

            Event.$on('fileStorageChanged', (callback) => {
                this.changeFileStorageModalIsVisible = false;
                this.getFile(callback);
            });
            
            Event.$on('backupFlagsChanged', (callback) => {
                this.configureBackupOptionsModalIsVisible = false;
                this.getFile(callback);
            });

            Event.$on('changeFileStorageModalClosed', () => {
                this.changeFileStorageModalIsVisible = false;
            });
            
            Event.$on('configureBackupOptionsModalClosed', () => {
                this.configureBackupOptionsModalIsVisible = false;
            });
        },
    },

    computed: {
        frequencyLabel() {
            if (this.file.frequency.hours == 24) {
                return 'Daily';
            }

            if (this.file.frequency.hours == 168) {
                return 'Weekly';
            }

            if (this.file.frequency.hours == 1) {
                return 'Every hour';
            }
            
            if (this.file.frequency.hours == 0.083) {
                return 'Every 5 minutes';
            }
            
            if (this.file.frequency.hours == 0.25) {
                return 'Every 15 minutes';
            }
            
            if (this.file.frequency.hours == 0.5) {
                return 'Every 30 minutes';
            }

            return 'Every ' + this.file.frequency.hours + ' hours';
        },

        frequentlyRetentionTitle() {
            if (this.file.retention.frequently == 1) {
                return 'Every hour';
            }

            if (this.file.frequency.hours == 0.083) {
                return 'Every 5 minutes';
            }
            
            if (this.file.frequency.hours == 0.25) {
                return 'Every 15 minutes';
            }
            
            if (this.file.frequency.hours == 0.5) {
                return 'Every 30 minutes';
            }

            return 'Every ' + this.file.frequency.hours + ' hours';
        },

        frequentlyRetentionLabel() {
            if (this.file.retention.frequently == 0) {
                return 'Not retained';
            }

            return 'Last ' + this.file.retention.frequently;
        },

        dailyRetentionLabel() {
            if (this.file.retention.daily == 0) {
                return 'Not retained';
            }

            return 'Last ' + this.file.retention.daily;
        },

        weeklyRetentionLabel() {
            if (this.file.retention.weekly == 0) {
                return 'Not retained';
            }

            return 'Last ' + this.file.retention.weekly;
        },

        monthlyRetentionLabel() {
            if (this.file.retention.monthly == 0) {
                return 'Not retained';
            }

            return 'Last ' + this.file.retention.monthly;
        },

        pausedActionLabel() {
            if (this.file.paused) {
                return 'Resume file backups';
            }
            return 'Pause file backups';
        },

        showDeletedFromProviderIcon() {
            return false;
            // return this.cloudlet.deleted_from_provider;
        },

        statusIconTooltip() {
            if (this.showActiveStatusIcon) {
                return 'Backups are taken as configured.';
            }

            if (this.showPausedStatusIcon) {
                return 'Backups are paused.';
            }
        },

        showActiveStatusIcon() {
            return !this.file.paused;
        },

        showPausedStatusIcon() {
            return this.file.paused;
        },

        multipleSnapshotsPerDay() {
            return this.file.frequency.hours < 24;
        },

        backupsStorage() {
            if (!this.file.backups_storage.amount) {
                return '0.00 KB';
            }

            return this.file.backups_storage.amount + ' ' + this.file.backups_storage.unit
        },

        fileTitle() {
            return this.file.name;
        },
    },
}
</script>
